import 'https://cdn.wetravel.com/widgets/embed_checkout.js';
import { ReserveThematic } from '@scripts/reserve-thematic/classes/ReserveThematic.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.reservation-popup').forEach(elm => {
        new ReserveThematic(elm);
    });
});
